/**
 * クルー用コンパスの磁気偏角は会場（フライトエリア）ごとに一度取得したら
 * 保持する（毎回位置情報から取り直さない）。goals.ts の
 * 「会場ごとにlocalStorageキーを分ける」方式にならう。
 */

export interface StoredDeclination {
  /** 磁気偏角 [度]。東偏+ */
  declinationDeg: number;
  /** 位置情報から自動取得したか、数値入力で手動調整したか */
  source: 'auto' | 'manual';
  /** 保存した日時 [epoch ms] */
  computedAt: number;
}

const KEY_PREFIX = 'gv4d-declination:';

export function loadDeclination(venueId: string): StoredDeclination | null {
  try {
    const raw = localStorage.getItem(KEY_PREFIX + venueId);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredDeclination;
    if (typeof parsed.declinationDeg !== 'number' || !Number.isFinite(parsed.declinationDeg)) return null;
    if (parsed.source !== 'auto' && parsed.source !== 'manual') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveDeclination(venueId: string, value: StoredDeclination): void {
  try {
    localStorage.setItem(KEY_PREFIX + venueId, JSON.stringify(value));
  } catch {
    // 保存できなくても、その場の操作は続けられる
  }
}
